import { RequestArguments } from '@sit/client-shared';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_REQUEST_FAILURE = 'GET_USER_REQUEST_FAILURE';
export const GET_USER_REQUEST_SUCCESS = 'GET_USER_REQUEST_SUCCESS';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_REQUEST_FAILURE = 'LOGIN_REQUEST_FAILURE';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';

export const PROTECTION_PWD_REQUEST = 'PROTECTION_PWD_REQUEST';
export const PROTECTION_PWD_REQUEST_FAILURE = 'PROTECTION_PWD_REQUEST_FAILURE';
export const PROTECTION_PWD_REQUEST_SUCCESS = 'PROTECTION_PWD_REQUEST_SUCCESS';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_REQUEST_FAILURE = 'REGISTER_REQUEST_FAILURE';
export const REGISTER_REQUEST_SUCCESS = 'REGISTER_REQUEST_SUCCESS';
export const REGISTER_SET_SUBMITTED = 'REGISTER_SET_SUBMITTED';

export const REGISTER_RESEND_EMAIL_REQUEST = 'REGISTER_RESEND_EMAIL_REQUEST';
export const REGISTER_RESEND_EMAIL_REQUEST_FAILURE = 'REGISTER_RESEND_EMAIL_REQUEST_FAILURE';
export const REGISTER_RESEND_EMAIL_REQUEST_SUCCESS = 'REGISTER_RESEND_EMAIL_REQUEST_SUCCESS';

export const REGISTER_EMPLOYEE_REQUEST = 'REGISTER_EMPLOYEE_REQUEST';
export const REGISTER_EMPLOYEE_REQUEST_FAILURE = 'REGISTER_EMPLOYEE_REQUEST_FAILURE';
export const REGISTER_EMPLOYEE_REQUEST_SUCCESS = 'REGISTER_EMPLOYEE_REQUEST_SUCCESS';

export const SEND_FALLBACK_MFA_CODE_REQUEST = 'SEND_FALLBACK_MFA_CODE_REQUEST';
export const SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE = 'SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE';
export const SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS = 'SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS';

export const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_REQUEST_FAILURE = 'UPDATE_PASSWORD_REQUEST_FAILURE';
export const UPDATE_PASSWORD_REQUEST_SUCCESS = 'UPDATE_PASSWORD_REQUEST_SUCCESS';

export const UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST = 'UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST';
export const UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_FAILURE = 'UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_FAILURE';
export const UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_SUCCESS = 'UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_SUCCESS';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_REQUEST_FAILURE = 'UPDATE_USER_REQUEST_FAILURE';
export const UPDATE_USER_REQUEST_SUCCESS = 'UPDATE_USER_REQUEST_SUCCESS';

// Temporary placement before move all feature to typescript;
export type MultiFactorAuthenticationProps =
  | {
      code: string;
    }
  | {
      fallbackToken: string;
    }
  | undefined;

export type LoginModel = {
  company: string;
  username: string;
  password: string;
  timezone: string;
  cb?: () => void;
};

export type LoginAction = LoginModel | (LoginModel & MultiFactorAuthenticationProps);

export type FallbackMultiFactorAuthenticationModel = {
  username: string;
  password: string;
  company: string;
};

export interface LoginRequestSagaPayload {
  data: {
    company: string;
    username: string;
    password: string;
    timezone: string;
    cb: () => void;
  } & RequestArguments;
}
